<template>
  <div>
    <div class="container">
      <el-form ref="query" :inline="true" :model="query" label-width="120px">
        <div>
          <el-form-item label="真实姓名:" prop="realName">
            <el-input
              v-model="query.realName"
              placeholder="真实姓名"
              :style="{ width: '220px' }"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员登录名:" prop="memberName">
            <el-input
              v-model="query.memberName"
              placeholder="会员登录名"
              :style="{ width: '220px' }"
            ></el-input>
          </el-form-item>
          <el-form-item label="拥有角色:" prop="roleName">
            <el-input
              v-model="query.roleName"
              placeholder="请输入员工拥有的角色"
              :style="{ width: '220px' }"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门查询:" prop="orgId">
            <div class="change-ma">
              <div v-show="query.organization != ''" class="ma-text">
                {{ query.organization }}
              </div>
              <el-button type="primary" @click="openSelectFilerDepartmentDialog"
                >选择部门</el-button
              >
            </div>
          </el-form-item>
        </div>
        <div class="button-block">
          <el-button class="clearButton" type="primary" @click="handleClear"
            >重置</el-button
          >

          <el-button class="searchButton" type="primary" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="container-external">
      <div class="container">
        <div style="margin-bottom: 20px">
          <el-button
            v-if="!isUnifyIdentity"
            type="primary"
            @click="handleAddUser"
            >新增员工</el-button
          >
          <el-button type="primary" @click="handleRelateDepartment"
            >新增已有员工</el-button
          >
          <el-button
            v-if="!isUnifyIdentity"
            type="primary"
            @click="handleImportUser"
            >导入员工</el-button
          >
          <el-button type="primary" @click="handleAssignRole"
            >分配角色</el-button
          >
          <!--          <el-button type="primary" @click="handleAssignDataAuth">分配数据权限</el-button>-->
          <el-button type="primary" @click="handleDelete">删除</el-button>
        </div>

        <TableList
          ref="tableList"
          :loading="loading"
          :table-data="tableData"
          :table-label="isUnifyIdentity == 1 ? tableLabel1 : tableLabel"
          :selection-show="true"
          :reserve-selection="false"
          :row-key="rowKey"
          @handleButton="handleButton"
          @handleSortChange="handleSortChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <template #index="slot">
            {{ slot.scope.$index + 1 }}
          </template>
          <template #roleSlot="slot">
            <div v-if="slot.scope.row.roleCount == 1">
              {{ slot.scope.row.roleList[0].roleName }}
            </div>
            <eui-btn
              v-if="slot.scope.row.roleCount > 1"
              type="link"
              size="12"
              class="text-blue"
              @click="handleUserRole(slot.scope.row)"
            >
              拥有 {{ slot.scope.row.roleCount }} 角色
            </eui-btn>
            <div v-if="slot.scope.row.roleCount == 0">暂无角色</div>
          </template>
          <template #optionsSlot="slot">
            <div v-if="isUnifyIdentity == 1">
              <eui-btn
                type="link"
                size="12"
                @click="handleCheck(slot.scope.row)"
                >查看</eui-btn
              >
            </div>
            <div v-if="isUnifyIdentity != 1">
              <eui-btn
                type="link"
                size="12"
                @click="handleCheck(slot.scope.row)"
                >查看</eui-btn
              >
              <eui-btn type="link" size="12" @click="handleEdit(slot.scope.row)"
                >编辑</eui-btn
              >
              <eui-btn
                type="link"
                size="12"
                @click="handleReset(slot.scope.row)"
                >重置密码</eui-btn
              >
            </div>
          </template>
        </TableList>
        <div class="pagination">
          <el-pagination
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPage.currentPage"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <add-user-dialog
      v-if="addUserDialogShow"
      :visible="addUserDialogShow"
      :dialog-title="dialogTitle"
      :user-data="userData"
      @close="closeUserDialog"
      @openSelectDepartmentDialog="openSelectDepartmentDialog"
      @openPrivacyAgreement="openPrivacyAgreement"
    ></add-user-dialog>
    <reset-password
      v-if="resetPasswordShow"
      :visible="resetPasswordShow"
      :user-data="userData"
      @close="closeResetPassword"
    ></reset-password>
    <CheckUserDialog
      v-if="checkUserShow"
      :visible="checkUserShow"
      :user-data="userData"
      @close="closeCheckUser"
    ></CheckUserDialog>
    <add-exist-user-dialog
      v-if="addExistUserDialogShow"
      :visible="addExistUserDialogShow"
      :dialog-title="dialogTitle1"
      @close="closeExistUserDialog"
    ></add-exist-user-dialog>
    <!-- 选择部门弹窗 -->
    <SelectDepartmentDialog
      v-if="selectDepartmentDialogShow"
      :visible="selectDepartmentDialogShow"
      @close="closeSelectDepartmentDialog"
      @getNode="getCurrentNode"
    ></SelectDepartmentDialog>

    <SelectDepartmentDialog
      v-if="selectFilterDepartmentDialogShow"
      :visible="selectFilterDepartmentDialogShow"
      @close="closeFilterSelectDepartmentDialog"
      @getNode="getFilterCurrentNode"
    ></SelectDepartmentDialog>
    <UserRoleListDialog
      v-if="userRoleListDialogShow"
      :visible="userRoleListDialogShow"
      :user-info="singleUserInfo"
      @close="closeUserRoleDialog"
    ></UserRoleListDialog>
    <privacy-agreement
      v-if="privacyAgreementShow"
      :visible="privacyAgreementShow"
      @close="privacyAgreementShow = false"
    ></privacy-agreement>
  </div>
</template>

<script>
import apiLogin from '@/modules/projectA/api/login/index';
import TableList from '../../components/common/e-table-list';
import AddUserDialog from '../../components/authority/addUserDialog';
import ResetPassword from '../../components/authority/resetPassword';
import CheckUserDialog from '../../components/authority/checkUserDialog';
import AddExistUserDialog from '../../components/authority/addExistUserDialog';
import SelectDepartmentDialog from '../../components/authority/selectDepartmentDialog';
import UserRoleListDialog from '../../components/authority/userRoleListDialog.vue';
import PrivacyAgreement from '../../components/authority/privacyAgreement';

import Api from '../../api/authority/index';
import { eventBus } from '../../main';

export default {
  name: 'UserManage',
  components: {
    TableList,
    AddUserDialog,
    ResetPassword,
    CheckUserDialog,
    AddExistUserDialog,
    SelectDepartmentDialog,
    UserRoleListDialog,
    PrivacyAgreement,
  },
  props: {},
  data() {
    return {
      query: {
        realName: '',
        memberName: '',
        orgId: '',
        organization: '',
        roleName: '',
      },
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '会员登录名', param: 'memberName', align: 'center' },
        { label: '真实姓名', param: 'realName', align: 'center' },
        { label: '业务方向', param: 'businessDirection', align: 'center' },
        { label: '手机号', param: 'mobile', align: 'center' },
        { label: '邮箱', param: 'email', align: 'center' },
        { label: '部门', param: 'orgName', align: 'center' },
        {
          label: '角色',
          param: 'roleCount',
          align: 'center',
          slot: 'roleSlot',
        },
        {
          label: '操作',
          param: 'options',
          align: 'center',
          slot: 'optionsSlot',
          width: '200',
        },
      ],
      tableLabel1: [
        { label: '统一身份认证账号', param: 'uid', align: 'center' },
        { label: '会员登录名', param: 'memberName', align: 'center' },
        { label: '业务方向', param: 'businessDirection', align: 'center' },
        { label: '真实姓名', param: 'realName', align: 'center' },
        { label: '手机号', param: 'mobile', align: 'center' },
        { label: '邮箱', param: 'email', align: 'center' },
        { label: '部门', param: 'orgName', align: 'center' },
        {
          label: '角色',
          param: 'roleCount',
          align: 'center',
          slot: 'roleSlot',
        },
        {
          label: '操作',
          param: 'options',
          align: 'center',
          slot: 'optionsSlot',
          width: '200',
        },
      ],
      tableOption: {
        label: '操作',
        width: '300',
        fixed: 'right',
        permission: '0',
        options: [
          {
            label: '查看',
            type: 'text',
            methods: 'handleCheck',
            permission: '/ubm/member/queryUserRole',
          },
          {
            label: '编辑',
            type: 'text',
            methods: 'handleEdit',
            permission: '/user-center/member/modifyMember',
          },
          {
            label: '重置密码',
            type: 'text',
            methods: 'handleReset',
            permission: '/user-center/member/resetPassword',
          },
        ],
      },
      tableOption1: {
        label: '操作',
        width: '300',
        fixed: 'right',
        permission: '0',
        options: [
          {
            label: '查看',
            type: 'text',
            methods: 'handleCheck',
            permission: '/ubm/member/queryUserRole',
          },
        ],
      },
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      addUserDialogShow: false,
      selectionData: [],
      resetPasswordShow: false,
      dialogTitle: '',
      checkUserShow: false,
      userData: {},
      rowKey: 'memberId',
      addExistUserDialogShow: false,
      dialogTitle1: '',
      selectDepartmentDialogShow: false,
      selectFilterDepartmentDialogShow: false,
      isUnifyIdentity: this.$store.state.USERINFO.unifyIdentity, /// 1是统一身份，0不是统一身份
      userRoleListDialogShow: false,
      singleUserInfo: {},
      getLoginFront: null,
      getLoginRear: null,
      privacyAgreementShow: false,
    };
  },
  computed: {},
  created() {
    console.log(
      this.$store.state.USERINFO.memberId,
      'this.$store.state.USERINFO.memberId'
    );
    this.getUserList();
  },
  mounted() {
    // 开启延长登录
    this.getLoginActive();
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
  methods: {
    handleSearch() {
      this.$refs.tableList.$refs.table.clearSelection();
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      this.getUserList();
    },
    handleClear() {
      (this.query = {
        realName: '',
        memberName: '',
        orgId: '',
        organization: '',
        roleName: '',
      }),
        this.handleSearch();
    },
    handleAddUser() {
      this.addUserDialogShow = true;
      this.dialogTitle = '新增员工';
    },
    handleRelateDepartment() {
      this.addExistUserDialogShow = true;
      this.dialogTitle1 = '新增已有员工';
    },
    handleImportUser() {
      this.$router.push({ path: '/institutionImport' });
    },
    handleAssignRole() {
      if (this.selectionData.length != 1) {
        this.$message({
          type: 'warning',
          message: '请选择一条数据',
        });
      } else {
        this.$router.push({
          name: 'assignRole',
          query: {
            memberId: this.selectionData[0].memberId,
            realName: this.selectionData[0].realName,
          },
        });
      }
    },
    handleAssignDataAuth() {
      if (this.selectionData.length != 1) {
        this.$message({
          type: 'warning',
          message: '请选择一条数据',
        });
      } else {
        this.$router.push({
          name: 'assignDataAuth',
          params: {
            memberId: this.selectionData[0].memberId,
            realName: this.selectionData[0].realName,
          },
        });
      }
    },
    handleReset(val) {
      this.resetPasswordShow = true;
      this.userData = val;
    },
    handleDelete() {
      if (!this.selectionData.length) {
        this.$message({
          type: 'warning',
          message: '请选择一条数据',
        });
      } else {
        const arr = [];
        for (let i = 0; i < this.selectionData.length; i++) {
          arr.push(this.selectionData[i].memberId);
        }
        const params = {
          memberIdList: arr,
        };

        this.$confirm('删除后不可恢复，确认删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            Api.deleteUser(params).then((res) => {
              if (res.code == '200') {
                this.$message({
                  type: 'info',
                  message: '删除成功',
                });
                this.productTagPage.currentPage = 1;
                this.getUserList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      }
    },
    handleSortChange() {},
    handleSelectionChange(val) {
      this.selectionData = val;
    },
    handleButton(val) {
      if (val.methods === 'handleCheck') {
        this.handleCheck(val.row);
      }
      if (val.methods === 'handleEdit') {
        this.handleEdit(val.row);
      }
      if (val.methods === 'handleReset') {
        this.handleReset(val.row);
      }
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getUserList();
    },
    closeUserDialog() {
      this.addUserDialogShow = false;
      this.productTagPage.currentPage = 1;
      this.getUserList();
    },
    closeResetPassword() {
      this.resetPasswordShow = false;
      this.getUserList();
    },
    closeExistUserDialog() {
      this.addExistUserDialogShow = false;
      this.productTagPage.currentPage = 1;
      setTimeout(() => {
        this.getUserList();
      }, 1000);
    },
    handleCheck(val) {
      this.checkUserShow = true;
      this.userData = val;
    },
    handleEdit(val) {
      this.addUserDialogShow = true;
      this.dialogTitle = '修改员工';
      this.userData = val;
    },
    closeCheckUser() {
      this.checkUserShow = false;
    },
    getUserList() {
      const params = {
        // companyId: 100422,
        memberName: this.query.memberName,
        realName: this.query.realName,
        pageSize: this.productTagPage.pageSize,
        pageNum: this.productTagPage.currentPage,
        orgId: this.query.orgId,
        organization: this.query.organization,
        roleName: this.query.roleName,
      };

      Api.queryUser(params).then((res) => {
        this.tableData = res.data.records;
        this.productTagPage.pageTotal = res.data.total;
      });
    },
    closeSelectDepartmentDialog() {
      // this.$refs.department.focus()
      this.selectDepartmentDialogShow = false;
    },
    openSelectDepartmentDialog() {
      this.selectDepartmentDialogShow = true;
    },
    openPrivacyAgreement() {
      this.privacyAgreementShow = true;
    },
    getCurrentNode(val) {
      // this.query.department = val.shortFullName
      // this.query.orgId = val.orgId
      eventBus.$emit('getDepartmentData', val);
    },

    closeFilterSelectDepartmentDialog() {
      this.selectFilterDepartmentDialogShow = false;
    },
    openSelectFilerDepartmentDialog() {
      this.selectFilterDepartmentDialogShow = true;
    },
    getFilterCurrentNode(val) {
      console.log(val);
      this.query.orgId = val.shortFullName;
      (this.query.orgId = val.orgId),
        (this.query.organization = val.shortFullName);
    },
    // 展示角色列表
    async handleUserRole(e) {
      console.log(e);
      this.singleUserInfo = e;
      this.userRoleListDialogShow = true;
    },
    // 关闭角色列表
    async closeUserRoleDialog() {
      this.userRoleListDialogShow = false;
    },
    // 心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      const token = this.$cookies.get('epecToken');
      if (token) {
        const epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        const now = new Date().getTime();
        const time = epecTokenExpiredTime;
        let timeOut = null;
        if (time > now) {
          const interval = time - now;
          console.log(interval);
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-external {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.container {
  width: 100%;
}
.button-block {
  width: 100%;
  display: flex !important;
  justify-content: center;
  display: inline-block;
  .searchButton {
    border: solid;
    border-width: 1px;
    border-color: #2587ff;
    background: #fff;
    color: #2587ff;
    min-width: 80px;
    transition: all 0.2s;
  }
  .searchButton:hover {
    border: solid;
    border-width: 1px;
    border-color: #2587ff;
    background: #e8efff;
    color: #2587ff;
    min-width: 80px;
    transition: all 0.2s;
  }
  .searchButton:active {
    border: solid;
    border-width: 1px;
    border-color: #0064c8;
    background: #e8efff;
    color: #0064c8;
    min-width: 80px;
    transition: all 0.2s;
  }
  .clearButton {
    min-width: 80px;
    border: solid;
    border-width: 1px;
    border-color: #c5c5c5;
    background: #fff;
    color: #333333;
    min-width: 80px;
    transition: all 0.2s;
  }
  .clearButton:hover {
    border: solid;
    border-width: 1px;
    border-color: #2587ff;
    background: #e8efff;
    color: #2587ff;
    min-width: 80px;
    transition: all 0.2s;
  }
  .clearButton:active {
    border: solid;
    border-width: 1px;
    border-color: #0064c8;
    background: #e8efff;
    color: #0064c8;
    min-width: 80px;
    transition: all 0.2s;
  }
}
.change-ma {
  display: flex;
  align-items: center;
  justify-content: start;
}
.ma-text {
  margin-right: 20px;
  color: #2587ff;
}
.text-blue {
  cursor: pointer;
}
</style>
